import { Button } from "../../components/ui/Button";

const InsuranceInfo = ({onGoToRegister}) => (
    <section
        className="flex relative w-full h-[400px] md:h-[500px] items-center justify-start px-6
        bg-cover bg-center md:bg-[url('/assets/idoso_medica.png')]"
    >
        {/* Card */}
        <div div className="w-full bg-white rounded-xl sm:shadow-lg p-6 sm:max-w-md w-full md:ml-16" >
            <h1 className="text-gray-800 text-3xl md:text-4xl font-bold leading-tight mb-4">
                Cuide do seu bem-estar com o <span className="text-orange-600">Bmg!</span>
            </h1>

            <p className="text-gray-700 text-base md:text-lg mb-6">
                Tenha acesso à diversos benefícios por menos de R$ 1 por dia.
            </p>

            <button onClick={onGoToRegister} className="bg-orange-600 hover:bg-orange-700 text-white font-semibold py-3 px-5 rounded-lg w-full transition">
                Contratar agora
            </button>
        </div >
    </section >
    // <section id="BenefitCardInfo" className={`h-auto bg-white text-white font-sans flex flex-col lg:flex-row`}>
    //     <div className="mt-20 w-full flex items-center justify-center">
    //         <div className="max-w-1/2 p-8 lg:pl-20 flex justify-center">
    //             <div className="">
    //                 <h1 className="text-gray-800 text-4xl lg:text-3xl font-bold leading-tight mb-4">
    //                     Cuide do seu bem-estar com o Bmg <br />
    //                     <small className="text-gray-800 text-sm">
    //                         Bmg Med e Seguro de Vida Familiar
    //                     </small>
    //                 </h1>

    //                 <p className="text-gray-800 text-lg mb-4">
    //                     Tenha acesso à diversos benefícios por menos de R$ 1 por dia.
    //                 </p>

    //                 <Button>Saiba como contratar</Button>
    //             </div>
    //             <img className="hidden bg-[#FA6300] rounded-lg md:block w-[450px]" src="/assets/idoso_medica.jpg" alt="hero-benefit-blocked" />
    //         </div>
    //     </div>
    // </section>
);
export default InsuranceInfo